import React from 'react';
import AppointmentDatePicker from './DatePicker';
import EnableDrag from './EnableDrag';
import DateRangerSummary from './DateRangerSummary';
import SummaryByStatus from './SummaryByStatus';
import SortingStaffSelected from './SortingStaffSelected';
import ButtonZoom from './ButtonZoom';

const CalendarFilter: React.FC = () => {
  return (
    <>
      <SummaryByStatus />
      <SortingStaffSelected />
      <AppointmentDatePicker v2 />
      <DateRangerSummary />
      <EnableDrag />
      <ButtonZoom />
    </>
  );
};

export default CalendarFilter;
